// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#widget-wrapper{all:initial;color:#2c3e50;font-family:Roboto,sans-serif;font-size:14px;padding:0}:focus{outline:none}.content-wrapper{padding:16px 16px 0 16px}.widget-body{margin:0}.dir-left{float:left}.dir-right{float:right}", ""]);
// Exports
module.exports = exports;
